<template>
  <div class="fullHeigthPage">
    <PageHeader :title="title" :items="items" />
    <div>
      <b-card>
        <b-card-title>
          <h5 class="card-title">Consultar</h5>
        </b-card-title>

        <div class="row">
          <b-form-group
            label="Ano"
            invalid-feedback="campo obrigatório"
            class="col-md-1"
            :state="state('ano')"
          >
            <date-picker
              v-model="dados.ano"
              type="year"
              value-type="YYYY"
              placeholder="Ano"
            ></date-picker>
          </b-form-group>

          <b-form-group label="Mês" class="col-md-1">
            <date-picker
              v-model="dados.mes"
              type="month"
              format="MM"
              value-type="MM"
              placeholder="Mês"
            ></date-picker>
          </b-form-group>

          <b-form-group
            label="Contrato Serviço"
            invalid-feedback="campo obrigatório"
            class="col-md-2"
            :state="state('contrato')"
          >
            <multiselect
              v-model="dados.contrato"
              placeholder="Selecione"
              :show-labels="false"
              :options="optionContrato"
              label="nome"
              :allow-empty="false"
              @input="inputContrato"
            />
          </b-form-group>

          <b-form-group
            label="Projeto"
            invalid-feedback="campo obrigatório"
            class="col-md-4"
          >
            <multiselect
              v-model="dados.projeto"
              placeholder="Selecione"
              :show-labels="false"
              :options="optionProjeto"
              label="nome"
              @input="inputProjeto"
            />
          </b-form-group>

          <b-form-group
            label="Cooperado"
            invalid-feedback="campo obrigatório"
            class="col-md-4"
          >
            <multiselect
              v-model="dados.cooperado"
              placeholder="Selecione"
              :show-labels="false"
              :options="optionCooperado"
              label="nome"
              :allow-empty="true"
            />
          </b-form-group>
        </div>
        <div class="row">
          <div class="d-flex justify-content-end">
            <div class="me-2 align-self-center mt-1">
              <b-button variant="primary" @click="filtrar()" class="m-1">
                <i
                  class="mdi mdi-filter-outline font-size-16 align-middle me-2"
                ></i>
                Filtrar
              </b-button>
            </div>
            <div div class="me-2 align-self-center mt-1">
              <b-button @click="limparFormulario()">
                <i class="mdi mdi-broom font-size-16 align-middle me-2"></i>
                Limpar
              </b-button>
            </div>
          </div>
        </div>
      </b-card>
    </div>
    <div class="d-flex justify-content-center" v-if="loading">
      <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
    </div>
    <div class="row">
      <div class="col-12 col-md-6">
        <div class="card" v-if="chart1">
          <div class="card-body">
            <h4 class="card-title mb-4">Gráfico de Limites vs. Despesas</h4>
            <div class="row text-center" v-if="valoresMensal.despesa">
              <div class="col-sm-6">
                <h5 class="mb-0">
                  {{ $tools.converteReal(valoresMensal.despesa) }}
                </h5>
                <p class="text-muted">Total Despesa</p>
              </div>
              <div class="col-sm-6">
                <h5 class="mb-0">
                  {{ $tools.converteReal(valoresMensal.limite) }}
                </h5>
                <p class="text-muted">Total Limite</p>
              </div>
            </div>
            <apexchart
              class="apex-charts"
              height="350"
              type="line"
              dir="ltr"
              :series="mixedChart.series"
              :options="mixedChart.chartOptions"
            ></apexchart>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-6" v-if="viewAcoes">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Ações Necessárias</h4>
            <div class="row">
              <div class="col-xl-3 col-sm-6">
                <div
                  @click="graficoAcoes('foraLimite')"
                  :class="
                    'card shadow-none border div-clickable ' +
                    fundoBotao('foraLimite')
                  "
                >
                  <div class="card-body p-3">
                    <div>
                      <h1 class="text-center text-blue">
                        {{ coopForaLimite.length }}
                      </h1>
                    </div>
                  </div>
                  <h6 class="text-center">Acima Limite Global</h6>
                </div>
              </div>

              <div class="col-xl-3 col-sm-6">
                <div class="card shadow-none border div-clickable">
                  <div class="card-body p-3">
                    <div class="">
                      <h1 class="text-center text-blue">0</h1>
                    </div>
                  </div>
                  <h6 class="text-center">Justificada pelo Cooperado</h6>
                </div>
              </div>

              <div class="col-xl-3 col-sm-6">
                <div
                  @click="graficoAcoes('dentroLimite')"
                  :class="
                    'card shadow-none border div-clickable ' +
                    fundoBotao('dentroLimite')
                  "
                >
                  <div class="card-body p-3">
                    <div class="">
                      <h1 class="text-center text-blue">
                        {{ coopDentroLimite.length }}
                      </h1>
                    </div>
                  </div>
                  <h6 class="text-center">Dentro Limite Global</h6>
                </div>
              </div>

              <div class="col-xl-3 col-sm-6">
                <div class="card shadow-none border div-clickable">
                  <div class="card-body p-3">
                    <div class="">
                      <h1 class="text-center text-blue">0</h1>
                    </div>
                  </div>
                  <h6 class="text-center">Pendente de Avaliação</h6>
                </div>
              </div>

              <b-table
                class="datatables"
                responsive="sm"
                :items="acoesList"
                :fields="campos"
                per-page="5"
                :current-page="currentPage"
              >
                <template v-slot:cell(cooperado)="data">
                  {{ data.item.cooperado + " [" + data.item.cd_pessoa + "]" }}
                </template>
                <template v-slot:cell(nm_projeto)="data">
                  {{ data.item.nm_projeto + " [" + data.item.cd_projeto + "]" }}
                </template>
                <template v-slot:cell(Detalhes)="data">
                  <b-button
                    class="mr-3"
                    variant="primary"
                    @click="detalhes(data.item)"
                    v-b-tooltip.hover
                    title="Download"
                  >
                    <i class="mdi mdi-send"></i>
                  </b-button>
                </template>
              </b-table>
              <div
                v-if="acoesList.length"
                class="dataTables_paginate paging_simple_numbers float-end"
              >
                <ul class="pagination pagination-rounded mb-0">
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="rows"
                    per-page="5"
                  ></b-pagination>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-6">
        <div class="card" v-if="chart2">
          <div class="card-body">
            <h4 class="card-title mb-4">Gráfico de Total por Despesa</h4>

            <apexchart
              class="apex-charts"
              height="350"
              type="bar"
              dir="ltr"
              :series="barChart.series"
              :options="barChart.chartOptions"
            ></apexchart>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-6" v-if="viewPodium">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">
              Ranking de Cooperados Mais Econômicos
            </h4>

            <div class="d-flex justify-content-center">
              <podium
                :listaRanking="listaRanking"
                class="mt-5 flex-responsivo"
              ></podium>
            </div>
          </div>
          <div
            class="d-flex justify-content-start align-items-center my-3 p-3"
            v-for="colocacao in listaRanking"
            :key="colocacao.posicao"
          >
            <h5 class="mx-3">{{ colocacao.posicao }}</h5>
            <img
              src="@/assets/images/users/avatar-4.jpg"
              data-holder-rendered="true"
              class="rounded-circle avatar-md d-flex justify-content-start"
            />
            <div class="d-flex mx-3" style="flex-direction: column">
              <h5 class="font-size-15 text-truncate">
                {{ colocacao.nomeCooperado }}
              </h5>
              <p class="text-muted mb-0 text-truncate">{{ colocacao.valor }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/page-header";
import Multiselect from "vue-multiselect";
import { required } from "vuelidate/lib/validators";
import podium from "@/components/graficos/podium";
import { barChart, mixedChart, mixedChartMensal } from "./data-apex";

export default {
  components: {
    PageHeader,
    Multiselect,
    podium,
  },
  data() {
    return {
      mixedChart: {},
      currentPage: 1,
      chart1: false,
      chart2: false,
      viewAcoes: false,
      viewPodium: false,
      barChart: {},
      title: "Dashboard | RDV (Relatório de Despesas de Viagem)",
      items: [
        {
          text: "RDV",
          active: false,
        },
        {
          text: "Dashboard",
          active: false,
        },
      ],
      submit: false,
      loading: false,
      filtro: [],
      dados: {
        contrato: null,
        matriz: null,
        projeto: null,
        cooperado: null,
        ano: null,
        mes: null,
      },
      optionContrato: [],
      optionProjeto: [],
      optionCooperado: [],
      valoresMensal: {
        despesa: 0,
        limite: 0,
      },
      acao: "",
      acoesList: [],
      campos: [
        {
          key: "cooperado",
          label: "Cooperado",
        },
        {
          key: "nm_projeto",
          label: "Projeto",
        },
        {
          key: "Detalhes",
          label: "",
        },
      ],
      coopDentroLimite: [],
      coopForaLimite: [],
      rows: 0,
    };
  },
  validations: {
    dados: {
      ano: {
        required,
      },
      contrato: {
        required,
      },
    },
  },
  created() {
    this.$store
      .dispatch("filtroTomador", this.$store.state.filtroTomador)
      .then((response) => {
        this.optionContrato =
          this.$tools.filtroTomador.selectContratos(response);
      });
  },
  methods: {
    state(param) {
      if (this.submit) {
        return !this.$v.dados[param].$invalid;
      } else {
        return null;
      }
    },
    inputContrato() {
      this.optionProjeto = [];
      this.optionCooperado = [];
      this.dados.projeto = null;
      this.dados.cooperado = null;
      this.dados.matriz = this.dados.contrato.matriz;
      this.optionProjeto = this.$tools.filtroTomador.selectProjetos(
        this.$store.state.filtroTomador,
        this.dados.contrato.numero
      );
    },
    inputProjeto() {
      if (!this.dados.projeto) {
        return;
      }
      this.optionCooperado = [];
      this.dados.cooperado = null;
      this.optionCooperado = this.$tools.filtroTomador.selectCooperados(
        this.$store.state.filtroTomador,
        this.dados.projeto.numero
      );
    },
    filtrar() {
      this.submit = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.limparDados();
      this.loading = true;
      var cooperado = "";
      var projeto = "";
      if (this.dados.projeto) {
        projeto = this.dados.projeto.numero;
      }

      if (this.dados.cooperado) {
        cooperado = this.dados.cooperado.numero;
      } else if (projeto) {
        this.optionCooperado.forEach((el) => {
          cooperado += el.numero + ",";
        });
        cooperado = cooperado.substr(0, cooperado.length - 1);
      }

      this.$http
        .post("api/rdvTomador/graficoLimitesDespesas", {
          tomador: this.dados.matriz,
          cooperado: cooperado,
          mes_referencia: this.dados.mes,
          ano_referencia: this.dados.ano,
          sq_contrato: this.dados.contrato.numero,
          cd_projeto: projeto,
        })
        .then((response) => {
          if (!this.dados.mes) {
            this.criarGraficoAnual(response);
          } else {
            this.criarGraficoMensal(response.data);
          }
          this.criarGraficoDespesas(response.data);
          this.$tools.fecharMenu();
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.$tools.alerta("Erro ao carregar graficos", "error");
          this.loading = false;
        });
    },
    criarGraficoAnual(response) {
      var despesas = [];
      var limite = [];
      var meses = [];
      var qtdeCooperado = [];
      var mes = parseInt(response.data[0].mes_referencia);
      var despesasAux = 0;
      var limiteAux = 0;
      var qtdeCooperadoAux = 0;
      var cooperado = [];

      response.data.forEach((el, key, arrayData) => {
        if (!cooperado.includes(el.cd_pessoa)) {
          cooperado.push(el.cd_pessoa);
          limiteAux += parseFloat(el.vl_limite_global_rdv);
          qtdeCooperadoAux++;
        }
        if (mes != parseInt(el.mes_referencia) || !arrayData[key + 1]) {
          meses.push(parseInt(arrayData[key - 1].mes_referencia));
          despesas.push(despesasAux.toFixed(3));
          limite.push(limiteAux);
          qtdeCooperado.push(qtdeCooperadoAux);

          cooperado = [];
          cooperado.push(el.cd_pessoa);
          limiteAux = parseFloat(el.vl_limite_global_rdv);
          qtdeCooperadoAux = 1;
          despesasAux = parseFloat(el.total_despesas);
          mes = parseInt(el.mes_referencia);
        } else {
          despesasAux += parseFloat(el.total_despesas);
          //limiteAux += parseFloat(el.vl_limite_global_rdv);
        }
      });
      this.mixedChart = mixedChart(meses, despesas, limite, qtdeCooperado);
      this.chart1 = true;
    },
    criarGraficoDespesas(retorno) {
      var aux = [];
      var nomeDespesa = [];
      retorno.forEach((el) => {
        if (!aux.includes(el.cd_norma)) {
          aux.push(el.cd_norma);
          nomeDespesa[aux.indexOf(el.cd_norma)] = {
            nome: el.despesa,
            valor: parseFloat(el.total_despesas),
          };
        } else {
          nomeDespesa[aux.indexOf(el.cd_norma)].valor += parseFloat(
            el.total_despesas
          );
        }
      });
      nomeDespesa.forEach((el, key) => {
        nomeDespesa[key].valor = parseFloat(nomeDespesa[key].valor.toFixed(2));
      });
      nomeDespesa = nomeDespesa.sort((a, b) => {
        if (a.valor < b.valor) {
          return 1;
        } else {
          return -1;
        }
      });
      this.chart2 = true;
      this.barChart = barChart(nomeDespesa);
    },
    criarGraficoMensal(retorno) {
      var cooperados = [];
      var despesas = [];
      var limite = [];
      var valorDespesas = 0;
      var proximaPessoa = 0;
      retorno.forEach((el, key, array) => {
        proximaPessoa = array[key + 1] ? array[key + 1] : null;
        if (!proximaPessoa || el.cd_pessoa != proximaPessoa.cd_pessoa) {
          valorDespesas += parseFloat(el.total_despesas);
          if (valorDespesas > parseFloat(el.vl_limite_global_rdv)) {
            this.coopForaLimite.push(el);
          } else {
            this.coopDentroLimite.push(el);
          }
          despesas.push(valorDespesas.toFixed(2));
          cooperados.push(el.cooperado);
          limite.push(parseFloat(el.vl_limite_global_rdv));
          valorDespesas = 0;
        } else {
          valorDespesas += parseFloat(el.total_despesas);
        }
      });
      this.mixedChart = mixedChartMensal(cooperados, despesas, limite);
      this.valoresMensal.despesa = despesas.reduce(this.$tools.reducer);
      this.valoresMensal.limite = limite.reduce(this.$tools.reducer);
      this.chart1 = true;
      this.viewAcoes = true;
    },
    graficoAcoes(acao) {
      if (acao == "foraLimite") {
        this.acao = acao;
        this.acoesList = this.coopForaLimite;
      } else if (acao == "dentroLimite") {
        this.acao = acao;
        this.acoesList = this.coopDentroLimite;
      }
      this.rows = this.acoesList.length;
    },
    limparFormulario() {
      this.dados.ano = null;
      this.dados.mes = null;
      this.dados.contrato = null;
      this.dados.matriz = null;
      this.dados.projeto = null;
      this.dados.cooperado = null;
    },
    limparDados() {
      this.valoresMensal.despesa = 0;
      this.valoresMensal.limite = 0;
      this.acoesList = [];
      this.coopDentroLimite = [];
      this.coopForaLimite = [];
      this.rows = 0;
      this.chart1 = false;
      this.chart2 = false;
      this.viewAcoes = false;
      this.viewPodium = false;
    },
    fundoBotao(param) {
      if (param == this.acao) {
        return "fundoAcao";
      } else {
        return "";
      }
    },
    detalhes(param) {
      var filtro = {
        matriz: this.dados.matriz,
        mes: this.dados.mes,
        ano: this.dados.ano,
        cooperado: { nome: param.cooperado, numero: param.cd_pessoa },
        contrato: this.dados.contrato,
        projeto: { nome: param.nm_projeto, numero: param.cd_projeto },
      };
      this.$store.commit("FILTRO_OPERACAO", filtro);
      this.$router.push("/tomadora/rdv/acompanhamento");
    },
  },
};
</script>
<style>
</style>